import React from 'react'
import { withTheme } from 'styled-components'
import Layout from '../Layout'
import Avatar from './Avatar'
import { getThemeStore } from '../storage'

export default withTheme((props) => {
  const { userInfo = {}, extendMap = {} } = props

  // 企业级的默认蓝色主题
  let theme = getThemeStore() || extendMap?.defaultTheme || userInfo.theme || 'themeS3'
  theme = theme === 'default' ? 'themeS3' : theme
  const newProps = {
    ...props,
    userInfo: {
      ...userInfo,
      theme,
    },
  }
  return <Layout {...newProps} AvatarCustom={Avatar} />
})
